<template>
  <div>
    <!-- 顶部背景图 -->
    <div class="top">
      <div class="t-t1">财务管理</div>
      <div class="t-t2box">
        <div class="t-t2">专业 高效 智慧 实现业务快速增长</div>
      </div>
    </div>

    <div class="row1">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">您是否因为信用卡逾期无力偿还感到困惑无助？</div>
        <br />
        <div class="t2">专业债务规划咨询</div>
      </div>

      <!-- 内容 -->

      <img class="img1" src="@/image/products/caichan/bingtu@2x.png" alt="" />
    </div>

    <div class="row6">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">一站式财务/债务解决方案</div>
        <br />
        <div class="t2">有效自律 合理规划</div>
      </div>

      <!-- 内容 -->
      <div class="box1">
        <div class="b1">
          <div class="l1">
            <img src="@/image/products/caichan/tubiao_fuzhai@2x.png" alt="" />
            <div class="t4">负债逾期</div>
            <div class="t5">信用卡 贷款逾期</div>
            <div class="t6">债务解决，合理规划方案，体验优质服务</div>
          </div>

          <div class="l1">
            <img src="@/image/products/caichan/tubiao_caiwu@2x.png" alt="" />
            <div class="t4">财务管理</div>
            <div class="t5">个人/企业财务</div>
            <div class="t6">财务管理方案，理财服务</div>
          </div>
        </div>

        <div class="b2"><img src="@/image/products/caichan/tu1@2x.png" alt="" /></div>
      </div>
    </div>

    <div class="row3">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">我们的服务</div>
        <br />
        <div class="t2">专于条例 诚于服务</div>
      </div>

      <!-- 内容 -->
      <div class="box1">
        <div class="item1">
          <div class="img">
            <img src="@/image/products/caichan/tubiao_gerencaiwu@2x.png" alt="" />
          </div>
          <div class="text1">个人财务</div>

          <div class="text2">财务问题</div>
          <div class="text3">财务问题 税务清缴 报账服务</div>
        </div>
        <div class="item1">
          <div class="img">
            <img src="@/image/products/caichan/tubiao_qiyecaiwu@2x.png" alt="" />
          </div>
          <div class="text1">企业财务</div>

          <div class="text2">公司财务 精准税务 财资服务</div>
          <div class="text3">精准税务 财资服务</div>
        </div>
        <div class="item1">
          <div class="img">
            <img src="@/image/products/caichan/tubiao_gerenzhaiwu@2x.png" alt="" />
          </div>
          <div class="text1">个人债务</div>

          <div class="text2">个人债务解决 方案规划</div>
          <div class="text3">方案规划</div>
        </div>
        <div class="item1">
          <div class="img">
            <img src="@/image/products/caichan/tubiao_qiyezhaiwu@2x.png" alt="" />
          </div>
          <div class="text1">企业债务</div>

          <div class="text2">全方位服务</div>
          <div class="text3">合理筹划解决债务</div>
        </div>
      </div>

      <div class="zixun" @click="goBto">立即咨询</div>
    </div>

    <div class="row7">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">使用场景</div>
        <br />
        <div class="t2">深度赋能企业调研，助力业务精确决策</div>
      </div>

      <!-- 内容 -->
      <div class="box3">
        <div class="item3">
          <img src="@/image/products/tu1@2x.png" class="img3" alt="" />

          <div class="btoom">
            <img src="@/image/products/diaoyan.png" alt="" />

            <div class="text3">科学多元化评估品牌元素对于消费者购买的影响力， 助力企业优化品牌设计，定制产品规划。</div>
          </div>
        </div>

        <div class="item3">
          <img src="@/image/products/tu2@2x.png" class="img3" alt="" />

          <div class="btoom">
            <img src="@/image/products/diaoyan.png" alt="" />

            <div class="text3">多维立体化的数据分析，直观呈现目前产品的市场规模与地位，助力企业找到差异化定位。</div>
          </div>
        </div>

        <div class="item3">
          <img src="@/image/products/tu3@2x.png" class="img3" alt="" />

          <div class="btoom">
            <img src="@/image/products/diaoyan.png" alt="" />

            <div class="text3">多渠道精准投放问卷，快速获取目前产品的消费市场偏好度，推动企业产品完成转型与升级。</div>
          </div>
        </div>
      </div>
    </div>

    <div class="row2">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">品质保障 安全无忧</div>
        <br />
        <div class="t2">专业高效</div>
      </div>

      <!-- row2内容 -->
      <div class="box2">
        <div class="r2-tiem">
          <img src="@/image/products/caichan/2000+@2x.png" alt="" />

          <div class="t2">做诚信之光</div>
        </div>

        <div class="r2-tiem">
          <img src="@/image/products/caichan/3w@2x.png" alt="" />

          <div class="t2">客户好评率达99%</div>
        </div>

        <div class="r2-tiem">
          <img src="@/image/products/caichan/3w@2x.png" alt="" />

          <div class="t2">服务咨询人数达3W+</div>
        </div>
      </div>
      <!-- 立即咨询
      <div class="zixun">立即咨询</div> -->
    </div>

    <div class="row5">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">多场景满意度测评 满足您不同的业务需求</div>
        <br />
        <div class="t2">助您洞察市场的真实情况</div>
      </div>

      <!-- 内容 -->
      <div class="box1">
        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu3@2x.png" alt="" />
          </div>

          <div class="text1">企业</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu4@2x.png" alt="" />
          </div>

          <div class="text1">零售</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu5@2x.png" alt="" />
          </div>

          <div class="text1">母婴</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu6@2x.png" alt="" />
          </div>

          <div class="text1">超市</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu7@2x.png" alt="" />
          </div>

          <div class="text1">餐饮</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu8@2x.png" alt="" />
          </div>

          <div class="text1">酒店</div>

          <div class="line"></div>
        </div>
      </div>

      <div class="zixun" @click="goBto">立即咨询</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DczxIndex',

  data() {
    return {}
  },

  mounted() {},

  methods: {
    //到底
    goBto() {
      document.getElementById('bot').scrollIntoView(true)
    },
  },
}
</script>

<style lang="scss" scoped>
.zixun {
  letter-spacing: 1px;
  position: absolute;
  bottom: 100px;
  left: 45%;
  width: 170px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  background-color: #4581fb;
  color: #fff;
  border-radius: 4px;
  // margin: 150px 0;
}

.top {
  z-index: -1;
  position: relative;
  height: 480px;
  background-image: url('@/image/products/caichan/banner@2x.png');
  background-repeat: no-repeat;

  .t-t1 {
    font-size: 60px;
    color: #000;
    position: absolute;
    z-index: 100;
    top: 28%;
    left: 20%;
  }

  .t-t2box {
    padding-left: 5px;
    color: #666666;
    z-index: 100;
    position: absolute;
    top: 48%;
    left: 20%;
    .t-t2 {
      font-size: 24px;
      margin: 10px 0;
    }
  }
}

.row1 {
  height: 630px;
  position: relative;

  .img1 {
    margin-top: 100px;
    position: absolute;
    top: 70px;
    left: 50%;
    transform: translateX(-50%);
    width: 1100px;
    height: 290px;
  }

  .title {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 65px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }
}

.row2 {
  height: 630px;
  overflow: hidden;

  background-color: #ffffff;
  position: relative;

  .title {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 90px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  // 内容
  .box2 {
    display: flex;

    width: 1300px;
    margin: 100px auto;
    justify-content: space-around;
    padding-left: 50px;

    .r2-tiem {
      background-color: #ffffff;
      height: 160px;
      width: 260px;
      position: relative;
      border-radius: 6px;

      img {
        margin-top: 0px;
        height: 230px;
        width: 210px;
      }

      .t2 {
        margin: 20px 0 0 -50px;
        text-align: center;
      }
    }
  }

  .zixun {
    letter-spacing: 1px;
    // position: absolute;
    bottom: 100px;
    width: 170px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background-color: #4581fb;
    color: #fff;
    border-radius: 2px;
    margin: 180px auto;
  }
}

.row3 {
  height: 750px;

  position: relative;

  .title {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 65px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  // 内容
  .box1 {
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    width: 1500px;
    height: 650px;

    margin: 120px auto 0 auto;
    box-sizing: border-box;
    padding-left: 150px;
    padding-top: 15px;

    .item1 {
      width: 280px;
      height: 320px;
      // border: 1px solid;
      margin-right: 40px;
      box-shadow: 1px 1px 5px 3px #efefef;

      .img {
        width: 90px;
        height: 85px;
        margin: 45px auto 18px auto;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .text1 {
        width: 250px;
        text-align: center;
        margin: 30px auto 16px auto;
        font-size: 18px;
        letter-spacing: 2px;
      }

      .text2 {
        letter-spacing: 2px;
        width: 250px;
        text-align: center;
        margin: 0px auto 2px auto;
        font-size: 15px;
        color: #999999;
      }
      .text3 {
        letter-spacing: 2px;
        width: 250px;
        text-align: center;
        margin: 0px auto 10px auto;
        font-size: 15px;
        color: #999999;
      }
    }
    .item1:hover {
      transform: translate(0, -8px);
      transition-duration: 0.2s;
      color: #4581fb;
      transition-timing-function: linear;
    }
  }
}

.row4 {
  height: 800px;
  background-color: #313131;
  position: relative;
  overflow: hidden;

  .title {
    margin-top: 40px;
    display: flex;
    color: #ffffff;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 95px;
      color: #ffffff;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  // 内容
  .box1 {
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    width: 1500px;
    height: 380px;

    margin: 150px auto 0 auto;
    box-sizing: border-box;
    padding-left: 150px;
    padding-top: 15px;

    .item1 {
      width: 380px;
      height: 120px;
      background-color: #404040;
      // border: 1px solid;
      display: flex;
      // justify-content: center;

      align-items: center;
      margin-right: 60px;
      // box-shadow: 1px 1px 5px 3px #efefef;

      .img {
        width: 64px;
        height: 64px;
        margin-left: 15px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .text1 {
        width: 200px;
        text-align: center;
        color: #ffffff;
        font-size: 18px;
        letter-spacing: 2px;
      }
    }
  }

  .zixun {
    letter-spacing: 1px;
    position: absolute;
    bottom: 100px;
    width: 170px;
    left: 850px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    border: 1px solid #ffffff;
    color: #fff;
    border-radius: 2px;
  }
}

.row5 {
  height: 700px;
  overflow: hidden;
  position: relative;
  background-image: url('@/image/products/caichan/beijing@2x.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  // z-index: -10;

  .title {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 115px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  .box1 {
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    width: 1700px;
    height: 650px;

    margin: 80px auto 0 auto;

    box-sizing: border-box;
    padding-left: 150px;
    padding-top: 15px;

    .item1 {
      width: 200px;
      height: 210px;
      position: relative;
      // border: 1px solid;
      margin-right: 30px;
      box-shadow: 1px 1px 5px 3px #efefef;

      .img {
        position: absolute;
        top: 0;
        width: 200px;
        height: 210px;
        z-index: 1;

        img {
          background-color: #000;
          opacity: 2;
          width: 100%;
          height: 100%;
        }
      }
      .img::after {
        content: ' ';
        z-index: 1;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: #000;
        opacity: 0.3;
      }

      .text1 {
        position: absolute;
        z-index: 100;
        width: 200px;
        text-align: center;
        margin: 140px auto 16px auto;
        color: #ffffff;
        font-size: 22px;
        text-align: center;
        letter-spacing: 2px;
      }
      .line {
        position: absolute;
        z-index: 100;
        background-color: #ffffff;
        bottom: 18px;
        left: 40%;
        height: 2px;
        width: 40px;
      }
    }
    .item1:hover {
      transform: translate(0, -8px);
      transition-duration: 0.2s;

      transition-timing-function: linear;
    }
  }
}

.row6 {
  height: 780px;
  overflow: hidden;
  position: relative;
  background-color: #313131;
  margin-bottom: 30px;

  .title {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      color: #ffffff;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 115px;
      color: #bbbbbb;
      font-size: 15px;
      letter-spacing: 2px;
    }
  }

  .box1 {
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    width: 1200px;
    height: 360px;
    margin: 150px auto 0 auto;
    box-sizing: border-box;

    .b1 {
      width: 50%;
      background-color: #313131;

      .l1 {
        border-radius: 8px;

        height: 150px;
        margin: 0 0 60px 60px;
        width: 500px;
        background-color: #383838;
        position: relative;
        img {
          margin-top: 40px;
          margin-left: 40px;
          width: 70px;
          height: 70px;
        }
        .t4 {
          font-size: 18px;
          position: absolute;
          top: 35px;
          left: 130px;

          color: #ffffff;
        }

        .t5 {
          position: absolute;
          letter-spacing: 1px;
          line-height: 30px;
          font-size: 16px;
          left: 130px;
          top: 70px;
          color: #bbbbbb;
        }

        .t6 {
          color: #bbbbbb;
          position: absolute;
          bottom: 90px;
          font-size: 16px;
          left: 130px;
          top: 105px;
        }
      }
    }

    .b2 {
      width: 50%;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .zixun {
    letter-spacing: 1px;
    // position: absolute;
    letter-spacing: 1px;
    width: 170px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background-color: #4581fb;
    color: #fff;
    border-radius: 2px;
    margin: 180px auto;
  }
}

.row7 {
  height: 870px;

  position: relative;
  overflow: hidden;

  background-color: #f7f8fb;

  .title {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 85px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  // 内容
  .box3 {
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    width: 1500px;
    height: 700px;

    margin: 80px auto 0 auto;
    box-sizing: border-box;
    padding-left: 150px;
    padding-top: 15px;

    .item3 {
      width: 370px;
      height: 650px;

      margin-right: 38px;

      .img3 {
        width: 100%;
        height: 450px;
      }

      .btoom {
        height: 100px;
        margin-top: 30px;
        box-shadow: 1px 1px 5px 3px #efefef;
        padding-left: 15px;
        img {
          margin: 15px 0 15px 0;

          width: 75px;
          height: 16px;
        }

        .text3 {
          font-size: 14px;
          color: #000000;
        }
      }
    }
  }
}
</style>
